<div [innerHtml]="text" style="word-wrap: break-word;" [style.font-size]="configuration.messageTextSize"></div>